import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading, isInitialized, checkAuthStatus } = useAuth();
  const location = useLocation();

  console.debug('[ProtectedRoute] Rendering:', { 
    isAuthenticated: !!user, 
    isLoading: loading,
    isInitialized: isInitialized,
    path: location.pathname,
    hasToken: !!localStorage.getItem('token')
  });

  // Check auth status when component mounts or when token exists but no user
  useEffect(() => {
    const token = localStorage.getItem('token');
    
    if (token && !user && !loading) {
      console.debug('[ProtectedRoute] Token exists but no user, checking auth status');
      checkAuthStatus();
    } else if (isInitialized && !loading && !user) {
      console.debug('[ProtectedRoute] No user after initialization, checking auth status');
      checkAuthStatus();
    }
  }, [isInitialized, loading, user, checkAuthStatus]);

  // Show loading state
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">Loading...</div>
      </div>
    );
  }

  // Check if we have a token but no user (possible race condition)
  const token = localStorage.getItem('token');
  if (token && !user && !loading) {
    console.debug('[ProtectedRoute] Token exists but no user yet, showing loading');
    return (
      <div className="loading-container">
        <div className="loading-spinner">Verifying authentication...</div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    console.debug('[ProtectedRoute] Not authenticated, redirecting to login');
    // Redirect to login page but save the attempted url
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  console.debug('[ProtectedRoute] Authenticated, rendering children');
  return children;
};

export default ProtectedRoute; 